import {
  Grid,
  GridItem,
  Radio,
  RadioGroup,
  Textarea
} from "@/storybook-components";
import { QuestionWithHeaderAndFooter } from "../question";
import { buildImgixUrl } from "@/lib";

import { QuestionContent } from "../question-content";

import { RadioQuestionProps } from "../types";

export const RadioButtonQuestion = (props: RadioQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionLabel,
    questionId,
    accessibilityTextOfRequired,
    questionLabelProps,
    questionLabelType,
    layoutProps,
    contentLayoutProps,
    answer,
    size,
    minImageWidth = 300,
    isDisabled,
    handleChange,
    answerStackSpacing,
    options,
    showTextAnswer,
    otherAnswer,
    otherAnswerClassName,
    otherAnswerSize,
    otherAnswerProps,
    isHorizontal,
    handleOtherAnswer,
    answerProps,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    layoutProps,
    questionId,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent {...contentLayoutProps}>
        <RadioGroup value={answer} onChange={handleChange} size={size}>
          <Grid
            templateColumns={{
              lg: `repeat(auto-fill, ${
                isHorizontal ? `${minImageWidth}px` : "1fr"
              })`
            }}
            alignItems="baseline"
            gap={answerStackSpacing}
          >
            {options &&
              options
                .filter((option) => !option.supportsTextAnswer)
                .map((option) => (
                  <GridItem
                    key={option.id}
                    sx={{
                      "@-moz-document url-prefix()": {
                        alignSelf: "normal"
                      }
                    }}
                  >
                    <Radio
                      value={option.id}
                      imageSrc={buildImgixUrl(option.imageUrl)}
                      imageAlt={option.imageAltText || option.name}
                      imageMinW={minImageWidth}
                      minH={{ base: "44px", lg: "auto" }}
                      {...answerProps}
                    >
                      {option.name}
                    </Radio>
                  </GridItem>
                ))}
          </Grid>
          {options &&
            options
              .filter((option) => option.supportsTextAnswer)
              .map((option) => (
                <Radio
                  key={option.id}
                  mt={answerStackSpacing}
                  value={option.id}
                  imageSrc={buildImgixUrl(option.imageUrl)}
                  imageAlt={option.imageAltText || option.name}
                  {...answerProps}
                >
                  {option.name}
                </Radio>
              ))}
        </RadioGroup>
        {showTextAnswer && (
          <Grid templateColumns="repeat(12, 1fr)">
            <GridItem colSpan={{ base: 12, lg: 10, "2xl": 4 }}>
              <Textarea
                isRequired
                aria-label={showTextAnswer.name}
                isDisabled={isDisabled}
                value={otherAnswer}
                onChange={handleOtherAnswer}
                className={otherAnswerClassName}
                size={otherAnswerSize}
                {...otherAnswerProps}
              />
            </GridItem>
          </Grid>
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
